import type { CheckoutLead } from '../../types';
import { StudentClassificationStatus } from '../../types';

export function canContinueCommercialCheckout(
  lead: Pick<CheckoutLead, 'has_paid' | 'classification' | 'student_id' | 'qualification' | 'qualification_id'>,
): boolean {
  if (lead.has_paid) {
    return false;
  }

  if (lead.classification?.status === StudentClassificationStatus.LEAD) {
    return true;
  }

  const isOrphanWithQualification = lead.student_id == null
    && (lead.qualification_id != null || lead.qualification != null);

  return isOrphanWithQualification;
}

/** Checkout may start a new subscription: no payment account, or no open subscription. */
export function shouldOfferCommercialCheckout(
  lead: Pick<CheckoutLead, 'can_start_new_checkout' | 'has_paid' | 'classification' | 'student_id' | 'qualification' | 'qualification_id'>,
): boolean {
  if (lead.can_start_new_checkout) {
    return true;
  }

  return canContinueCommercialCheckout(lead);
}

/** Shows the Checkout control for unpaid candidates and for leads that already paid. */
export function shouldShowCommercialCheckoutLink(
  lead: Pick<CheckoutLead, 'has_paid' | 'classification' | 'student_id' | 'qualification' | 'qualification_id'>,
): boolean {
  if (lead.has_paid) {
    return true;
  }

  return canContinueCommercialCheckout(lead);
}

/** Project-attributed leads still show classification; temperature and persona stay hidden. */
export function shouldShowCommercialLeadProfileTags(
  lead: Pick<CheckoutLead, 'project'>,
): boolean {
  return !lead.project;
}

export function formatCommercialOwnerLabel(
  name: string,
  ownerPortalUserId: number | null | undefined,
  currentPortalUserId: number | null | undefined,
): string {
  const label = name.trim();
  if (!label) {
    return name;
  }

  if (
    currentPortalUserId != null
    && ownerPortalUserId != null
    && currentPortalUserId === ownerPortalUserId
  ) {
    return `${label} (você)`;
  }

  return label;
}
